<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.5 6.599a3 3 0 10-3 0v4.234a.5.5 0 00.1.3l1 1.334a.5.5 0 00.8 0l1-1.334a.5.5 0 00.1-.3V10L3 9.25l1.5-.75V6.599zM4 4a1 1 0 11-2 0 1 1 0 012 0zM8.306 1h-.163.163zm2.38 13.998c1.54-.012 2.425-.075 3.13-.434a4 4 0 001.748-1.748C16 11.96 16 10.84 16 8.6V7.4c0-2.24 0-3.36-.436-4.216a4 4 0 00-1.748-1.748c-.706-.36-1.59-.423-3.134-.434a1.25 1.25 0 00-1.149.988 4.455 4.455 0 00-.042.29l-.187 1.434A9.758 9.758 0 017.39 8.366l-.493.648a.926.926 0 00.736 1.486c1.03 0 1.867.836 1.867 1.867V13.5c0 .25 0 .32.006.373a1.25 1.25 0 001.18 1.125zM11.75 8.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
    fill="currentColor"
  />
</svg>
